import React from "react";

import { ResponseType, OptionsType } from "commons/types/http";

import useHttpManaged from "hooks/useHttpManaged";

import { PathParamsWithId } from "commons/types/api/common";

import { SectionOneBody, SectionOneDetails } from "types/api/blocks/sectionOne";

function useSectionOneApi() {
    const { get, del, post } = useHttpManaged();
    const getOneSectionOne = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<SectionOneDetails> => {
        return get<PathParamsWithId, undefined, SectionOneDetails>({
            url: "/blocks/section-one/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [get]);
    const saveSectionOne = React.useCallback((body: SectionOneBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return post<undefined, undefined, SectionOneBody, null>({
            url: "/blocks/section-one",
            body: body,
            options: options,
            headers: headers
        });
    }, [post]);
    const deleteSectionOne = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return del<PathParamsWithId, undefined, null>({
            url: "/blocks/section-one/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [del]);
    return {
        getOneSectionOne,
        saveSectionOne,
        deleteSectionOne
    };
}

export default useSectionOneApi;